/* @flow */
// typecheck: ignore file
import { takeLatest } from 'redux-saga';
import { fork, call, put } from 'redux-saga/effects';
import { loadMembershipsSuccess, loadMembershipSuccess } from 'reducers/peopleTables';
import type { LoadMembershipsAction, LoadMembershipAction } from 'reducers/peopleTables';
import GroupMembership from 'entities/GroupMembership';
import API from 'lib/RemindAPI';

type Sort = 'first_name' | 'last_name' | 'join_date' | 'role';
type SortDirection = 'desc' | 'asc';

export type ClassMembershipFetchOptions = {
  page: number,
  perPage: number,
  sortDirection?: SortDirection,
  userIds?: number[],
  sort?: Sort,
  roles?: string[],
  query?: string,
}

function fetchMembership(groupId: number | string, userId: number) {
  return API.request(`/classes/${groupId}/members/${userId}`, 'GET').then(
    response => GroupMembership.fromJSON(response)
  );
}

function fetchMemberships(groupId: number | string, parameters: ClassMembershipFetchOptions) {
  const options = {
    sort_type: parameters.sort,
    per_page: parameters.perPage,
    user_ids: parameters.userIds,
    sort_direction: parameters.sortDirection,
    roles: parameters.roles,
    page: parameters.page,
    q: parameters.query,
  };

  return API.request(`/classes/${groupId}/members`, 'GET', options).then(
    response => response.members.map(member => GroupMembership.fromJSON(member))
  );
}

function* fetchClassMembership(action: LoadMembershipAction): Generator<?any, ?any, ?any> {
  try {
    // $FlowFixMe
    const membership = yield call(fetchMembership, action.groupId, action.userId);

    if (membership) {
      yield put(loadMembershipSuccess(action.groupId, membership, action.options));
    }
  } catch (e) {
    console.error(e);
  }
}

function* fetchClassMemberships(action: LoadMembershipsAction): Generator<?any, ?any, ?any> {
  try {
    // $FlowFixMe
    const memberships = yield call(fetchMemberships, action.groupId, action.options);

    if (memberships) {
      yield put(loadMembershipsSuccess(action.groupId, memberships, action.options));
    }
  } catch (e) {
    console.error(e);
  }
}

function* watchFetchMemberships(): Generator<?any, ?any, ?any> {
  // $FlowFixMe
  yield* takeLatest('peopleTables/LOAD_MEMBERSHIPS_REQUEST', fetchClassMemberships);
}

function* watchFetchMembership(): Generator<?any, ?any, ?any> {
  // $FlowFixMe
  yield* takeLatest('peopleTables/LOAD_MEMBERSHIP_REQUEST', fetchClassMembership);
}

export default function* root(): Generator<?any, ?any, ?any> {
  yield [
    fork(watchFetchMemberships),
    fork(watchFetchMembership),
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/peopleTables.js